import React, { ReactNode } from 'react'
import './split.css';

interface Props {
    children : ReactNode
    reverse? : boolean;
}

export class Split extends React.Component<Props> {

    getClasses() 
    {
        if (this.props.reverse === undefined || !this.props.reverse) {
            return "split";
        }
        else {
            return "split reverse";
        }
    }

    render() {
        return (
            <div className={ this.getClasses() }>
                { this.props.children }
            </div>
        );
    }
}

